import { Helmet } from "react-helmet-async";
// @mui
import { Container, Typography } from "@mui/material";
// components
import SitesMenu from "../sections/@dashboard/sites/SitesMenu";
import SitesView from "../sections/@dashboard/sites/SitesView";

// ----------------------------------------------------------------------

export default function SitesPage() {
  return (
    <>
      <Helmet>
        <title> Dashboard: Standorte </title>
      </Helmet>

      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 5 }}>
          Standorte
        </Typography>

        <SitesMenu />
        <SitesView />
      </Container>
    </>
  );
}
